import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { addNewTechniqueAction } from '../../utils/redux/techniques/techniquesAction';

const AddTechniqueModal = ({ show, handleClose, techniqueCategories, onSuccess }) => {
    const dispatch = useDispatch();
    const [form, setForm] = useState({
        title: '',
        durationHhmmss: '',
        keywords: '',
        category: '',
        techniqueLink: '',
        summary: '',
        description: '',
    });
    const [errors, setErrors] = useState({});

    const validate = () => {
        const errs = {};
        if (!form.title.trim()) errs.title = 'Title is required';
        if (!form.durationHhmmss) errs.durationHhmmss = 'Duration is required';
        return errs;
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errs = validate();
        setErrors(errs);
        if (Object.keys(errs).length > 0) return;

        // Prepare data
        const data = {
            ...form,
            keywords: form.keywords ? form.keywords.split(',').map(k => k.trim()).filter(Boolean) : [],
        };
        const res = await dispatch(addNewTechniqueAction(data));
        if (res?.success) {
            handleClose();
            setForm({
                title: '',
                durationHhmmss: '',
                keywords: '',
                category: '',
                techniqueLink: '',
                summary: '',
                description: '',
            });
            if (onSuccess) onSuccess();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Add New Technique</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Title <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="title"
                                    value={form.title}
                                    onChange={handleChange}
                                    isInvalid={!!errors.title}
                                    placeholder="Technique Title"
                                />
                                <Form.Control.Feedback type="invalid">{errors.title}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Duration (hh:mm:ss) <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    name="durationHhmmss"
                                    value={form.durationHhmmss}
                                    onChange={handleChange}
                                    isInvalid={!!errors.durationHhmmss}
                                    placeholder="e.g. 01:30:00"
                                />
                                <Form.Control.Feedback type="invalid">{errors.durationHhmmss}</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Category</Form.Label>
                                <Form.Select
                                    name="category"
                                    value={form.category}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Category</option>
                                    {techniqueCategories?.map(cat => (
                                        <option key={cat._id} value={cat._id}>{cat.name}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Keywords <small>(comma separated)</small></Form.Label>
                                <Form.Control
                                    name="keywords"
                                    value={form.keywords}
                                    onChange={handleChange}
                                    placeholder="e.g. frontend, backend"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Technique Link</Form.Label>
                                <Form.Control
                                    name="techniqueLink"
                                    value={form.techniqueLink}
                                    onChange={handleChange}
                                    placeholder="https://..."
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    name="description"
                                    value={form.description}
                                    onChange={handleChange}
                                    placeholder="Technique description"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Summary</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    name="summary"
                                    value={form.summary}
                                    onChange={handleChange}
                                    placeholder="Summary text"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={handleClose} className="me-2">
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Add Technique
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddTechniqueModal;